import { JsonFormsRendererRegistryEntry } from "@jsonforms/core";

//layouts
import { GridTableViewEntry } from "./renderers/layout/GridTableView";
import { HorizontalLayoutEntry } from "./renderers/layout/HorizontalLayout";
import { StepLayoutEntry } from "./renderers/layout/Step";
import { TabLayoutEntry } from "./renderers/layout/Tab";
import { VerticalLayoutEntry } from "./renderers/layout/VerticalLayout";
import { VerticalStepsEntry } from "./renderers/layout/VerticalSteps";
import { VerticalSectionsEntry } from "./renderers/layout/VerticalSections";
import { SectionLayoutEntry } from "./renderers/layout/Section";
import { SummaryLayoutEntry } from "./renderers/layout/SummaryLayout";
import { LoaderLayoutEntry } from "./renderers/layout/LoaderLayout";
import { TextLayoutEntry } from "./renderers/layout/TextLayout";
import { PaymentSuccessEntry } from "./renderers/layout/PaymentSuccess";
import { ArrayDynamicFormLayout } from './renderers/layout/ArrayDynamicFormLayout';

//controls
import { ButtonControlEntry } from "./renderers/controls/Button";
import { LabelControlEntry } from "./renderers/controls/LabelControl";
import { TextInputControlEntry } from "./renderers/controls/TextInput";
import { CurrencyInputControlEntry } from "./renderers/controls/CurrencyInput";
import { TextareaInputControlEntry } from "./renderers/controls/TextareaInput";
import { SelectControlEntry } from "./renderers/controls/SelectInput";
import { BooleanInputControlEntry } from "./renderers/controls/BooleanInput";
import { NumberInputControlEntry } from "./renderers/controls/NumberInput";
import { DatepickerInputControlEntry } from "./renderers/controls/Datepicker";
import { SelectControlOneOfEntry } from "./renderers/controls/SelectInputOneOf";
import { RadioInputControlEntry } from "./renderers/controls/RadioInput";
import { ToggleControlEntry } from "./renderers/controls/Toggle";
import { MultiSelectControlEntry } from "./renderers/controls/MultiSelect";
import { HorizontalFieldsEntry } from "./renderers/layout/HorizontalFields";
import { QuoteActionsEntry } from "./renderers/layout/QuotesActionLayou";
import { QuotesLayoutEntry } from "./renderers/layout/Quotes";
import { QuotesCoveragesEntry } from "./renderers/layout/QuotesCoverages";
import { PurchaseLayoutEntry } from "./renderers/layout/Purchase";
import { DatePickerWithDuration } from "./renderers/controls/DatePickerWithDuration";
import { DependentDropdownEntry } from "./renderers/controls/DependentDropdown";
import { HorizontalFieldsActionsEntry } from "./renderers/layout/HorizontalFieldsActions";
import { ControlWithButtonWrapperEntry } from "./renderers/layout/ControlWithButton";
import { ButtonWithActionEntry } from "./renderers/controls/ButtonWithAction";
import { PremiumHeaderEntry } from "./renderers/controls/PremiumHeader";
import { DisplayInputEntry } from "./renderers/controls/DisplayInput";
import { InfoControlEntry } from "./renderers/controls/InfoControl";

const controls = [
  ButtonControlEntry,
  LabelControlEntry,
  TextInputControlEntry,
  CurrencyInputControlEntry,
  TextareaInputControlEntry,
  SelectControlEntry,
  BooleanInputControlEntry,
  NumberInputControlEntry,
  DependentDropdownEntry,
  DatepickerInputControlEntry,
  SelectControlOneOfEntry,
  RadioInputControlEntry,
  ToggleControlEntry,
  DatePickerWithDuration,
  MultiSelectControlEntry,
  ButtonWithActionEntry,
  PremiumHeaderEntry,
  DisplayInputEntry,
  InfoControlEntry
];

const layouts = [
  GridTableViewEntry,
  HorizontalFieldsEntry,
  HorizontalLayoutEntry,
  StepLayoutEntry,
  TabLayoutEntry,
  VerticalLayoutEntry,
  VerticalStepsEntry,
  VerticalSectionsEntry,
  SectionLayoutEntry,
  QuoteActionsEntry,
  QuotesLayoutEntry,
  QuotesCoveragesEntry,
  PurchaseLayoutEntry,
  ControlWithButtonWrapperEntry,
  HorizontalFieldsActionsEntry,
  LoaderLayoutEntry,
  PaymentSuccessEntry,
  SummaryLayoutEntry,
  TextLayoutEntry,
  ArrayDynamicFormLayout
];

export const renderers: JsonFormsRendererRegistryEntry[] = [
  ...controls,
  ...layouts,
];
